import React from 'react';
import { Card, CardContent, Typography, Box, Divider } from '@mui/material';
import { Work } from '@mui/icons-material';

interface WorkExperience {
  jobTitle?: string;
  title?: string;
  companyName?: string;
  company?: string;
  location?: string;
  startDate?: string;
  start_date?: string;
  endDate?: string;
  end_date?: string;
  isCurrentJob?: boolean;
  description?: string;
}

interface ProfileWorkExperienceProps {
  workExperience?: WorkExperience[];
}

export default function ProfileWorkExperience({ workExperience }: ProfileWorkExperienceProps) {
  if (!workExperience || workExperience.length === 0) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <Work sx={{ mr: 1 }} />
          <Typography variant="h6">Work Experience</Typography>
        </Box>
        {workExperience.map((exp: WorkExperience, index: number) => (
          <Box key={index} mb={3}>
            <Typography variant="subtitle1" fontWeight="bold">
              {exp.jobTitle || exp.title || 'Position'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {exp.companyName || exp.company || 'Company'} 
              {exp.location ? ` • ${exp.location}` : ''}
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {exp.startDate || exp.start_date || ''} - {exp.endDate || exp.end_date || (exp.isCurrentJob ? 'Present' : '')}
            </Typography>
            {exp.description && (
              <Typography variant="body2" paragraph>
                {exp.description}
              </Typography>
            )}
            {index < workExperience.length - 1 && <Divider sx={{ my: 2 }} />}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}